const UnusedLotData = {
  banned: false,
  currCode: '',
  currencyID: '',
  endTime: 0,
  endTimeUTC: 0,
  houseID: '',
  insurance: '',
  isRestricted: false,
  isRfcLot: false,
  originalLotID: 0,
  pieceTitle: '',
  potentiallyBanned: false,
  status: ''
};

export default UnusedLotData;
